import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#6E6E7D",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": ".845",
      d: "M8.136 3.322h-.361v-.361z",
      style: {"stroke":"color(display-p3 .4296 .4296 .4915)","stroke-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#A7A7B1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": ".845",
      d: "M3.747 1.915h2.257q.009.001.016.008a.03.03 0 0 1 .006.014l.002.017V3.76l.002.067.001.018a1.324 1.324 0 0 0 1.235 1.221l.07.003h.016v-.423.423H9.16q.01.002.016.008.006.007.007.015v4.061a.93.93 0 0 1-.868.927l-.073.003H3.747h0a.93.93 0 0 1-.929-.868l-.002-.062h.001v-6.31a.93.93 0 0 1 .869-.927z",
      style: {"stroke":"color(display-p3 .6543 .6543 .6951)","stroke-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }